export default {
  category: "object",
  type: "cloned",
};
